var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgStop = function SvgStop(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4155 4H5.08452C4.797 4.00038 4.52137 4.11476 4.31806 4.31806C4.11476 4.52137 4.00038 4.797 4 5.08452V15.4155C4.00038 15.703 4.11476 15.9786 4.31806 16.1819C4.52137 16.3852 4.797 16.4996 5.08452 16.5H15.4155C15.703 16.4996 15.9786 16.3852 16.1819 16.1819C16.3852 15.9786 16.4996 15.703 16.5 15.4155V5.08452C16.4996 4.797 16.3852 4.52137 16.1819 4.31806C15.9786 4.11476 15.703 4.00038 15.4155 4ZM15.3636 15.3636H5.13636V5.13636H15.3636V15.3636Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 11,
    height: 11
  })));
};
export default SvgStop;